<template>
    <div data-test="directors-index">
        <!-- Table Container Card -->
        <b-card no-body class="mb-0" data-test="director-table">
            <director-table
                :payload-for-director-table="payloadForDirectorTable"
                @add="add"
                @view="view"
                @edit="edit"
                @remove="remove"
            />

            <pending-approval-director-table
                v-if="shouldShowPendingDirectorTable"
                :payload-for-pending-director-table="payloadForPendingDirectorTable"
                :pending-directors="pendingDirectors"
                @view="view"
                @approve="approve"
            />

            <pending-approval-update-particulars-of-director-table
                v-if="shouldShowPendingApprovalUpdateParticularsOfDirectorTable"
                :payload-for-pending-update-particulars-of-directors-table="payloadForPendingUpdateParticularsOfDirectorsTable"
                :pending-update-of-directors-particulars="pendingUpdateOfDirectorsParticulars"
                @view="viewUpdateOfParticulars"
                @approve="approveUpdateOfParticulars"
            />
        </b-card>
    </div>
</template>

<script>
import {
    BCard,
} from "bootstrap-vue";
import DirectorTable from './DirectorTable.vue';
import PendingApprovalDirectorTable from './PendingApprovalDirectorTable.vue';
import PendingApprovalUpdateParticularsOfDirectorTable from './PendingApprovalUpdateParticularsOfDirectorTable.vue';

export default {
    components: {
        BCard,

        DirectorTable,
        PendingApprovalDirectorTable,
        PendingApprovalUpdateParticularsOfDirectorTable,
    },

    props: {
        payloadForDirectorTable: {
            type: Object,
            required: true
        },

        payloadForPendingDirectorTable: {
            type: Object,
            required: true
        },

        payloadForPendingUpdateParticularsOfDirectorsTable: {
            type: Object,
            required: true
        }
    },
    
    computed: {
        shouldShowPendingDirectorTable() {
            return this.pendingDirectors?.length > 0;
        },

        shouldShowPendingApprovalUpdateParticularsOfDirectorTable() {
            return this.pendingUpdateOfDirectorsParticulars?.length > 0;
        }
    }, 

    methods:{
        add(){
            this.$emit('add');
        },

        view(director) {
            this.$emit('view', director, "view");
        },

        edit(director) {
            this.$emit('edit', director, "edit");
        },

        remove(director) {
            this.$emit('remove', director);
        },

        approve(director) {
            this.$emit('approve', director);
        },

        viewUpdateOfParticulars(updateOfParticularsData) {
            this.$emit('viewUpdateOfParticulars', updateOfParticularsData);
        },

        approveUpdateOfParticulars(updateOfParticularsData) {
            this.$emit('approveUpdateOfParticulars', updateOfParticularsData);
        },
    },

    setup(props) {
        const { 
            pendingDirectors, 
            pendingUpdateOfDirectorsParticulars 
        } = props.payloadForDirectorTable;

        return { 
            pendingDirectors,
            pendingUpdateOfDirectorsParticulars,
        };
    }
};
</script>